import { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

function WarningIcon(props: SvgIconProps) {
  return (
    <svg {...props} width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5002 3.62489C8.49407 3.62489 3.62516 8.49379 3.62516 14.4999C3.62516 20.506 8.49407 25.3749 14.5002 25.3749C20.5063 25.3749 25.3752 20.506 25.3752 14.4999C25.3752 8.49379 20.5063 3.62489 14.5002 3.62489ZM1.2085 14.4999C1.2085 7.1591 7.15938 1.20822 14.5002 1.20822C21.8409 1.20822 27.7918 7.1591 27.7918 14.4999C27.7918 21.8407 21.8409 27.7915 14.5002 27.7915C7.15938 27.7915 1.2085 21.8407 1.2085 14.4999Z"
        fill="white"
      />
      <path
        d="M14.5185 6.57797C15.5807 6.57797 16.1119 7.54365 16.1119 9.475C16.1119 10.5224 15.9707 11.9932 15.6884 13.8874C15.4062 15.7816 15.1759 16.9181 14.9976 17.297C14.8788 17.557 14.7191 17.687 14.5185 17.687C14.2956 17.687 14.1248 17.5718 14.0059 17.3415C13.8425 17.0518 13.616 15.9896 13.3263 14.1548C13.0365 12.32 12.8843 10.7601 12.8694 9.475C12.8694 7.54365 13.4191 6.57797 14.5185 6.57797ZM14.4851 19.1243C14.9308 19.1243 15.3282 19.2989 15.6773 19.648C16.0264 19.9972 16.201 20.3946 16.201 20.8403C16.201 21.2934 16.0301 21.6908 15.6884 22.0325C15.3467 22.3742 14.9456 22.5451 14.4851 22.5451C14.0171 22.5451 13.616 22.3779 13.2817 22.0437C12.9474 21.7019 12.7803 21.3008 12.7803 20.8403C12.7803 20.3797 12.9511 19.9786 13.2928 19.6369C13.6345 19.2952 14.0319 19.1243 14.4851 19.1243Z"
        fill="white"
      />
    </svg>
  );
}

const MemoWarningIcon = React.memo(WarningIcon);
export default MemoWarningIcon;
